var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoodbye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.705 50.035L20 57.626S21.262 71.61 35.696 74l7.778-7.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.502 37.878c5.676.211 9.247-3.938 9.247-3.938L58.6 19.045a3.55 3.55 0 015.03 0 3.573 3.573 0 010 5.044L53.195 34.561a.45.45 0 00.621.653l14.4-12.15a3.55 3.55 0 015.012.44 3.573 3.573 0 01-.44 5.025l-14.12 11.914a.4.4 0 00.505.616l9.789-6.877a3.548 3.548 0 014.953.876 3.573 3.573 0 01-.873 4.967l-9.503 6.681a.802.802 0 00.451 1.462.786.786 0 00.414-.116l6.262-3.65c1.7-.984 3.876-.4 4.858 1.307a3.572 3.572 0 01-1.301 4.872l-12.668 6.405s-12.268 15.82-26.981 4.577c0 0-7.426-4.919-6.656-15.532 0 0 .07-4.567-3.853-10.822 0 0-2.382-3.584.56-4.849 0 0 3.504-2.108 5.606.984 0 0 4.763 5.411 5.464 10.681"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M63.47 72.566c3.794.575 6.957-1.024 9.487-4.795m-13.748.995c5.569.453 9.29-1.639 11.163-6.275M43.87 13.903c-3.826-.308-6.869 1.507-9.13 5.445M48.316 17.4c-5.588-.064-9.154 2.282-10.699 7.038"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF94CA",
    d: "M87.097 87.147c.025.024-.024.072-.048.096-4.005.515-8.06.74-12.092.601-.049 0-.073-.024-.097-.048a19.214 19.214 0 01-.597-4.3c-.026-.266.19-.482.456-.505l7.339-.163c.048 0 .072-.023.072-.072-.033-2.1-.046-5.094-.079-7.194 0-.049.024-.073.073-.072l4.49.163c.049 0 .073.025.073.073.002.434.18 8.402.41 11.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0046AA",
    d: "M14.553 70.212c-1.83 1.188-3.638-1.848-1.744-2.948 1.872-1.122 3.68 1.694 1.744 2.948zm.724 2.046c-.383 2.2 3.02 2.706 3.319.506.319-2.332-2.915-2.706-3.32-.506zm3.276 3.806c-.362 2.2 3.107 2.728 3.32.506.212-2.332-2.958-2.706-3.32-.506z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.297,
    cy: 15.297,
    r: 3,
    fill: "#FF94CA",
    fillRule: "nonzero",
    transform: "rotate(-174 6.297 15.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.198,
    cy: 7.198,
    r: 2,
    fill: "#0046AA",
    fillRule: "nonzero",
    transform: "rotate(-174 10.198 7.198)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodbye);
export default __webpack_public_path__ + "static/media/goodbye.6bffee33.svg";
export { ForwardRef as ReactComponent };